import { Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { clientDay, dateTimeNoSeconds } from './dateTime';

/**
 * Kolumny dat w listach react-admina — ten sam zapis co reszta interfejsu.
 *
 * `DateField` formatuje sam, przez `toLocaleString` przeglądarki: bez
 * jawnych opcji „1.09.2026”, z opcjami wynik zależny od ICU przeglądarki.
 * Obok komórek z „01.09.2026” wyglądało to jak dwa różne systemy
 * (30.09.2026). Te pola czytają wartość z rekordu i oddają ją formatom
 * z `shared/dateTime.ts` — zawsze z zerem, zawsze w czasie polskim.
 *
 * `source` i `label` czyta też `Datagrid`: nagłówek i klucz sortowania
 * zostają jak przy `DateField`.
 */
export interface DateColumnProps {
  source: string;
  label?: string;
  sortable?: boolean;
  sortBy?: string;
}

const valueAt = (record: Record<string, unknown> | undefined, source: string): string | null => {
  const v = record?.[source];
  return typeof v === 'string' && v !== '' ? v : null;
};

/** „28.09.2026, 10:34” — chwila w czasie polskim, bez sekund. */
export const DateTimeField = ({ source }: DateColumnProps) => {
  const record = useRecordContext();
  return (
    <Typography component="span" variant="body2" sx={{ whiteSpace: 'nowrap' }}>
      {dateTimeNoSeconds(valueAt(record, source))}
    </Typography>
  );
};

/** „28.09.2026” — dzień w Polsce, w którym wypada chwila. */
export const ClientDayField = ({ source }: DateColumnProps) => {
  const record = useRecordContext();
  return (
    <Typography component="span" variant="body2" sx={{ whiteSpace: 'nowrap' }}>
      {clientDay(valueAt(record, source))}
    </Typography>
  );
};
